query MetadataFields($campaignId: ID!) {
    metadataFields(campaignId: $campaignId) {
        _id
        name
    }
}
